import { render, staticRenderFns } from "./index.vue?vue&type=template&id=236bff56&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=236bff56&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236bff56",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBreadCrumb: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppBreadCrumb.vue').default,CmsRichText: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsRichText.vue').default,StoreDetailsMap: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/store/StoreDetailsMap.vue').default,AppCampaignBanner: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppCampaignBanner.vue').default,StoreOpenDetails: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/store/StoreOpenDetails.vue').default,AppContainer: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppContainer.vue').default})
